import { api } from "@/lib/api";
import { hasConsent } from "@/lib/consent";

function getUtm() {
  try {
    const p = new URLSearchParams(window.location.search);
    const stored = JSON.parse(localStorage.getItem("sc_utm") || "{}");
    const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "fbclid"];
    const fresh = {};
    keys.forEach((k) => { if (p.get(k)) fresh[k] = p.get(k); });
    const merged = { ...stored, ...fresh };
    if (Object.keys(fresh).length) localStorage.setItem("sc_utm", JSON.stringify(merged));
    return merged;
  } catch { return {}; }
}

export function attribution() {
  const utm = getUtm();
  return {
    ...utm,
    source: utm.utm_source ? utm.utm_source : (document.referrer && !document.referrer.includes(window.location.host) ? "referral" : "organic"),
    medium: utm.utm_medium || "",
    campaign: utm.utm_campaign || "",
    landing_page: window.location.pathname,
    referrer: document.referrer || "",
    device: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop",
  };
}

export function track(event, meta = {}) {
  try {
    if (!hasConsent("analytics")) return;
    api.post("/events", { event, page: window.location.pathname, meta }).catch(() => {});
    if (window.dataLayer && hasConsent("marketing")) window.dataLayer.push({ event, ...meta });
  } catch { /* noop */ }
}
